import Schema from "async-validator";

export async function checkValidator(model, rules) {
  try {
    await new Schema(rules).validate(model);
  } catch (error) {
    const fields = error.fields;
    const errors = {};
    for (const key in fields) {
      errors[key] = fields[key]
        .map((item) => item.message)
        .filter(Boolean)
        .join(";");
    }
    return errors;
  }
}
